/* Caipi Redesign — header mega menu + mobile drawer.
   Desktop opens on CLICK (first click opens the panel, second navigates),
   outside-click + Escape close, plus the mobile drawer (accordion, scroll lock). */
(function () {
  'use strict';

  function initHeader(root) {
    if (root.dataset.rdInit === '1') return;
    root.dataset.rdInit = '1';

    /* ---- Desktop: click + keyboard open for mega items ---- */
    var megaItems = root.querySelectorAll('[data-rd-nav-item].rd-hdr__nav-item--mega');
    function closeAllMega(except) {
      megaItems.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var l = it.querySelector('.rd-hdr__nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    }
    megaItems.forEach(function (item) {
      var link = item.querySelector('.rd-hdr__nav-link');
      if (!link) return;
      // Klick togglet das Panel: 1. Klick öffnet, 2. Klick schließt. Der Top-Link
      // navigiert NICHT — Navigation läuft über die Links im Panel. Desktop & Touch.
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var wasOpen = item.classList.contains('is-open');
        closeAllMega(null);
        if (!wasOpen) {
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
      link.addEventListener('focus', function () { closeAllMega(item); });
      // Schließen per X-Button.
      var closeBtn = item.querySelector('[data-rd-mega-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          item.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
        });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllMega(null); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-rd-nav-item].rd-hdr__nav-item--mega')) closeAllMega(null);
    });

    /* ---- Mobile drawer ---- */
    var drawer = root.querySelector('[data-rd-mob]');
    var backdrop = root.querySelector('.rd-mob__backdrop');
    function openMob() {
      if (drawer) { drawer.hidden = false; drawer.setAttribute('data-open', ''); }
      if (backdrop) { backdrop.hidden = false; backdrop.setAttribute('data-open', ''); }
      document.body.style.overflow = 'hidden';
      var b = root.querySelector('[data-rd-menu-open]');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
    function closeMob() {
      if (drawer) drawer.removeAttribute('data-open');
      if (backdrop) backdrop.removeAttribute('data-open');
      document.body.style.overflow = '';
      var b = root.querySelector('[data-rd-menu-open]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    root.querySelectorAll('[data-rd-menu-open]').forEach(function (b) { b.addEventListener('click', openMob); });
    root.querySelectorAll('[data-rd-menu-close]').forEach(function (b) { b.addEventListener('click', closeMob); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMob(); });

    /* Mobile drill (Root → Category → Art-Preview, slide + back) */
    var mobTitle = root.querySelector('[data-rd-mob-title]');
    var mobBack = root.querySelector('[data-rd-mob-back]');
    var mobViewport = root.querySelector('.rd-mob__viewport');
    var rootPanel = root.querySelector('[data-rd-mob-panel="root"]');
    var artPanel = root.querySelector('[data-rd-mob-panel="art"]');
    var artGrid = root.querySelector('[data-rd-mob-art-grid]');
    var artAll = root.querySelector('[data-rd-mob-art-all]');
    var mobStack = []; // breadcrumb of {panel, title} to return to

    function mobHideAll() {
      root.querySelectorAll('.rd-mob__panel').forEach(function (p) { p.hidden = true; p.classList.remove('is-active'); });
    }
    function mobShowPanel(panel, title) {
      mobHideAll();
      if (panel) { panel.hidden = false; panel.classList.add('is-active'); }
      if (mobTitle) mobTitle.textContent = title || 'Sortiment';
      if (mobBack) mobBack.hidden = mobStack.length === 0;
      if (mobViewport) mobViewport.scrollTop = 0;
    }
    function mobShowRoot() {
      mobStack = [];
      mobShowPanel(rootPanel, 'Sortiment');
    }
    // Level 1 → 2: open a category panel
    root.querySelectorAll('[data-rd-mob-drill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = root.querySelector('[data-rd-mob-cat="' + btn.getAttribute('data-rd-mob-drill') + '"]');
        if (!panel) return;
        mobStack.push({ panel: rootPanel, title: 'Sortiment' });
        mobShowPanel(panel, btn.getAttribute('data-rd-mob-drill-title') || 'Kategorie');
      });
    });
    // Level 2 → 3: open the shared Art-preview panel, fetch products on demand
    function mobLoadArt(handle) {
      if (!artGrid || !handle) return;
      if (artCache[handle] !== undefined) {
        artGrid.innerHTML = artCache[handle] || '<p class="rd-mob__art-empty">Keine Produkte gefunden.</p>';
        return;
      }
      artGrid.innerHTML = '<p class="rd-mob__art-empty">Lädt …</p>';
      fetch('/collections/' + handle + '/products.json?limit=12')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.products || !d.products.length) {
            artCache[handle] = '';
            artGrid.innerHTML = '<p class="rd-mob__art-empty">Keine Produkte gefunden.</p>';
            return;
          }
          var html = tilesHTML(d.products);
          artCache[handle] = html;
          artGrid.innerHTML = html || '<p class="rd-mob__art-empty">Keine Produkte gefunden.</p>';
        })
        .catch(function () { artGrid.innerHTML = '<p class="rd-mob__art-empty">Keine Produkte gefunden.</p>'; });
    }
    root.querySelectorAll('[data-rd-mob-art]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!artPanel) return;
        var url = btn.getAttribute('data-rd-mob-art-url');
        var curPanel = root.querySelector('.rd-mob__panel.is-active');
        mobStack.push({ panel: curPanel, title: mobTitle ? mobTitle.textContent : '' });
        if (artAll && url) artAll.setAttribute('href', url);
        mobLoadArt(btn.getAttribute('data-rd-mob-art'));
        mobShowPanel(artPanel, btn.getAttribute('data-rd-mob-art-title') || 'Sorte');
      });
    });
    if (mobBack) mobBack.addEventListener('click', function () {
      var prev = mobStack.pop();
      if (prev && prev.panel) { mobShowPanel(prev.panel, prev.title); }
      else { mobShowRoot(); }
    });
    // reset to root each time the drawer opens
    root.querySelectorAll('[data-rd-menu-open]').forEach(function (b) { b.addEventListener('click', mobShowRoot); });

    /* --- Per-sub-category product preview: hovering an "Art" loads its
       top seeds into that panel's Top-Picks column (fetched on demand,
       cached per collection). Keeps the header DOM light. --- */
    var artCache = {};
    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function truncWords(s, n) {
      var w = String(s || '').split(/\s+/);
      return w.length > n ? w.slice(0, n).join(' ') + '…' : s;
    }
    function tilesHTML(products) {
      // Nur lieferbare/vorbestellbare Artikel: mind. eine Variante mit available=true
      // (true bei Lagerbestand ODER inventory_policy 'continue'/Vorbestellung).
      return (products || []).filter(function (p) {
        return p.variants && p.variants.some(function (v) { return v && v.available; });
      }).slice(0, 4).map(function (p) {
        var href = '/products/' + p.handle;
        var src = (p.images && p.images[0]) ? p.images[0].src : (p.featured_image || '');
        if (src.indexOf('//') === 0) src = 'https:' + src;
        var img = src
          ? '<div class="rd-mega__tile-img"><img src="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200" loading="lazy" alt=""></div>'
          : '<div class="rd-mega__tile-img"></div>';
        var price = (p.variants && p.variants[0])
          ? parseFloat(p.variants[0].price).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
          : '';
        var brand = p.vendor ? '<span class="rd-mega__tile-brand">' + esc(p.vendor) + '</span>' : '';
        return '<a href="' + href + '" class="rd-mega__tile">' + img + brand +
          '<span class="rd-mega__tile-name">' + esc(truncWords(p.title, 5)) + '</span>' +
          '<span class="rd-mega__tile-price">' + price + '</span></a>';
      }).join('');
    }
    function loadArt(art) {
      var panel = art.closest('.rd-mega');
      if (!panel) return;
      var grid = panel.querySelector('[data-rd-picks-grid]');
      var eyebrow = panel.querySelector('[data-rd-picks-eyebrow]');
      var allLink = panel.querySelector('[data-rd-picks-all]');
      var handle = art.getAttribute('data-rd-art');
      if (!handle || !grid) return;
      if (eyebrow) eyebrow.textContent = 'Top-Picks · ' + art.getAttribute('data-rd-art-title');
      if (allLink && art.getAttribute('data-rd-art-url')) allLink.setAttribute('href', art.getAttribute('data-rd-art-url'));
      if (artCache[handle] !== undefined) { grid.innerHTML = artCache[handle]; return; }
      fetch('/collections/' + handle + '/products.json?limit=12')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.products || !d.products.length) { artCache[handle] = ''; return; }
          var html = tilesHTML(d.products);
          artCache[handle] = html;
          if (html) grid.innerHTML = html;
        })
        .catch(function () {});
    }
    var hoverTimer;
    root.querySelectorAll('.rd-mega__art[data-rd-art]').forEach(function (art) {
      art.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { loadArt(art); }, 120);
      });
      art.addEventListener('focus', function () { loadArt(art); });
    });
  }

  function init() {
    document.querySelectorAll('rd-header.rd-hdr').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
